import React from 'react';
import PropTypes from 'prop-types';

class Theme extends React.Component {
  static contextTypes = {
    themes: PropTypes.object.isRequired,
  };

  state = this.context.themes.get();

  componentDidMount() {
    this.unsubscribe = this.context.themes.subscribe(this.setState.bind(this));
  }

  componentWillUnmount() {
    this.unsubscribe && this.unsubscribe();
  }

  render() {
    return null;
  }
}

export default function withTheme(Component) {
  return class ThemeProvider extends Theme {
    static WrappedComponent = Component;

    render() {
      return (
        <Component
          theme={this.state.theme}
          {...this.props}
        />
      );
    }
  };
}

// Оставляем withNonPureTheme для обратной совместимости
export const withNonPureTheme = withTheme;
